"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _api = require("../api");

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _VideoTool = _interopRequireDefault(require("../components/VideoTool"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var NEW_KEYWORD = 'new';

function VideoTool(props) {
  var videoId = props.match.params.videoId,
      history = props.history;
  var isNewVideo = !videoId || videoId === 'new';
  var videoIdProp = !isNewVideo ? videoId : void 0;

  if (!videoId) {
    history.push("builder/".concat(NEW_KEYWORD));
  }

  return /*#__PURE__*/_react.default.createElement(_commonReact.AuthorisationConsumer, null, function (_ref) {
    var organisationId = _ref.selectedOrganisation.organisationId;
    return /*#__PURE__*/_react.default.createElement(_commonReact.RequestProvider, {
      requests: {
        createVideo: (0, _api.createVideoApi)(organisationId),
        getVideo: (0, _api.getVideoApi)(videoId),
        getProject: (0, _api.getProjectApi)(),
        updateVideo: (0, _api.updateVideoApi)(videoId),
        deleteAssets: (0, _api.deleteAssetsApi)(),
        archiveAssets: (0, _api.archiveAssetsApi)(),
        archiveAsset: (0, _api.archiveAssetApi)(),
        updateProject: (0, _api.updateProjectApi)(),
        submitVideo: (0, _api.submitVideoApi)(videoId),
        updateAllOutputs: (0, _api.updateAllOutputsApi)(videoId),
        getOutputStatuses: (0, _api.getOutputStatusesApi)(),
        requestVideoBriefChanges: (0, _api.requestVideoBriefChangesApi)(videoId)
      }
    }, function (_ref2) {
      var createVideo = _ref2.createVideo,
          getVideo = _ref2.getVideo,
          getProject = _ref2.getProject,
          updateVideo = _ref2.updateVideo,
          deleteAssets = _ref2.deleteAssets,
          archiveAssets = _ref2.archiveAssets,
          archiveAsset = _ref2.archiveAsset,
          updateProject = _ref2.updateProject,
          submitVideo = _ref2.submitVideo,
          updateAllOutputs = _ref2.updateAllOutputs,
          getOutputStatuses = _ref2.getOutputStatuses,
          requestVideoBriefChanges = _ref2.requestVideoBriefChanges;
      return /*#__PURE__*/_react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref3) {
        var fetchAssets = _ref3.fetchAssets,
            fetchAssetsForResource = _ref3.fetchAssetsForResource;
        return /*#__PURE__*/_react.default.createElement(_VideoTool.default, _extends({
          createVideo: createVideo,
          fetchAssets: fetchAssets,
          fetchAssetsForResource: fetchAssetsForResource,
          history: history,
          getVideo: getVideo,
          getProject: getProject,
          updateVideo: updateVideo,
          deleteAssets: deleteAssets,
          archiveAssets: archiveAssets,
          archiveAsset: archiveAsset,
          updateProject: updateProject,
          videoId: videoIdProp,
          submitVideo: submitVideo,
          updateAllOutputs: updateAllOutputs,
          getOutputStatuses: getOutputStatuses,
          requestVideoBriefChanges: requestVideoBriefChanges
        }, props));
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, VideoTool);

exports.default = _default;